import * as React from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import styled from "styled-components";

type Props = ButtonProps;

const StyledButton = styled.div`
  & > button {
    padding: ${props => props.theme.spacing(0.5)}px;
    min-width: 0;
    width: 100%;
  }
`;

export const DefaultButton: React.FunctionComponent<Props> = props => {
  return (
    <StyledButton>
      <Button {...props}></Button>
    </StyledButton>
  );
};
